import React from "react";
import ReactDom from "react-dom";

import {observable, action, computed} from 'mobx';
import {observer} from 'mobx-react';

import BaseViewStore from 'base-viewstore';


export class InputFieldViewStore extends BaseViewStore {

    attributes = {
        accept: null,
        align: null,
        alt: null,
        autoComplete: null,
        autoFocus: null,
        checked: null,
        disabled: null,
        list: null,
        max: null,
        maxLength: null,
        min: null,
        name: null,
        pattern: null,
        placeholder: null,
        readOnly: null,
        required: null,
        step: null,
        type: null,
        value: null,
        tabIndex: null,
    };

    events = {
        onCopy: null,
        onCut: null,
        onPaste: null,
        onKeyDown: null,
        onKeyUp: null,
        onKeyPress: null,
        onFocus: null,
        onBlur: null,
        onChange: null,
        onClick: null,
        onDoubleClick: null,
        onMouseDown: null,
        onMouseEnter: null,
        onMouseLeave: null,
        onMouseOut: null,
        onMouseOver: null,
        onMouseUp: null,
        onSelect: null,
        onWheel: null,
        onScroll: null,
    };

    @observable lastValue = null;
    @observable value = null;
    @observable valid = false;
    @observable hasFocus = false;
    @observable hovering = false;
    
    waitingForHover = false;

    constructor(props) {
        super(props);

        this.value = this.props.contentModel.value;
        this.lastValue = this.value;

        if(this.props.form) {
            this.props.form.controls.push(this);
        }

        this.validate();
    }

    @action.bound validate() {

        const value = this.value;
        this.valid = value !== undefined && value != "" && value != null;
    }

    @computed get hasChanged() {
        return this.props.contentModel.value != this.value;
    }

    @action.bound onChange(value) {
        if(this.props.contentModel.isReadOnly || this.props.contentModel.disabled || this.props.form.props.contentModel.isSubmitted) {
            return;
        }
        this.value = value;
    }

    @action.bound onFocus() {
        if(this.props.contentModel.isReadOnly || this.props.contentModel.disabled || this.props.form.props.contentModel.isSubmitted) {
            return;
        }
        this.hasFocus = true;
    }
    @action.bound onBlur() {
        if(this.props.contentModel.isReadOnly || this.props.contentModel.disabled || this.props.form.props.contentModel.isSubmitted) {
            return;
        }
        this.hasFocus = false;

        this.validate();

        if(this.props.form) {
            this.props.form.update();
        }
    }
    
    @action.bound onKeyUp(e) {
        if(this.props.contentModel.isReadOnly || this.props.contentModel.disabled || this.props.form.props.contentModel.isSubmitted) {
            return;
        }
        
        if(e.key == "Enter" && this.hasFocus) {
            e.currentTarget.blur();
        } 
    }

    // validation is a derivation
    @computed get invalid() {
        const invalid = {};
        return invalid;
    }  

    @action.bound save() {
        this.props.contentModel.value = this.value;
    }

    @action.bound update() {

        if(!this.props.form || !this.props.contentModel.variable || (typeof (this.props.form.dbVariableStore[this.props.contentModel.variable])) === 'undefined' || this.hasFocus) {
            return;
        }

        if(['NumberInputField_ExplorationField67', 'NumberInputField_ExplorationField68', 'NumberInputField_ExplorationField69'].indexOf(this.props.contentModel.id) >= 0 && this.props.form.dbVariableStore["G:FI_RES_RunExplorationR1P1:G"] != 1) {
            this.value = "";
        }
        else if(['NumberInputField_ExplorationField46', 'NumberInputField_ExplorationField47', 'NumberInputField_ExplorationField48'].indexOf(this.props.contentModel.id) >= 0 && this.props.form.dbVariableStore["G:FI_RES_RunExplorationR1P2:G"] != 1) {
            this.value = "";
        }
        else if(['NumberInputField_411', 'NumberInputField_305', 'NumberInputField_681'].indexOf(this.props.contentModel.id) >= 0 && this.props.form.dbVariableStore["G:FI_RES_RunExplorationR2P1:G"] != 1) {
            this.value = "";
        }
        else if(['NumberInputField_ExplorationField88', 'NumberInputField_ExplorationField89', 'NumberInputField_ExplorationField90'].indexOf(this.props.contentModel.id) >= 0 && this.props.form.dbVariableStore["G:FI_RES_RunExplorationR2P2:G"] != 1) {
            this.value = "";
        }
        else if(this.props.contentModel.id == "NumberInputField_ProductionField35") {
            this.value = parseFloat(this.props.form.dbVariableStore["G:FI_RES_UpstreamRevenue:G"]) - parseFloat(this.props.form.dbVariableStore["G:FI_RES_UpstreamOpProfit:G"]);
        }
        else if(this.props.contentModel.id == "NumberInputField_54") {
            this.value = parseFloat(this.props.form.dbVariableStore["G:FI_RES_IncomeFromOps:G"]) / parseFloat(this.props.form.dbVariableStore["G:FI_RES_TotRevenue:G"]);
        }
        else if(this.props.contentModel.id == "NumberInputField_732") {
            this.value = parseFloat(this.props.form.dbVariableStore["G:FI_DEV_TotalUndevReservesR1P1:G"]) * (parseFloat(this.props.form.dbVariableStore["G:FI_DEC_PercentToDevelopLevelR1P1:G"]) * 0.02);
        }
        else if(this.props.contentModel.id == "NumberInputField_162") {
            this.value = parseFloat(this.props.form.dbVariableStore["G:FI_DEV_TotalUndevReservesR1P2:G"]) * (parseFloat(this.props.form.dbVariableStore["G:FI_DEC_PercentToDevelopLevelR1P2:G"]) * 0.02);
        }
        else if(this.props.contentModel.id == "NumberInputField_274") {
            this.value = parseFloat(this.props.form.dbVariableStore["G:FI_DEV_TotalUndevReservesR2P1:G"]) * (parseFloat(this.props.form.dbVariableStore["G:FI_DEC_PercentToDevelopLevelR2P1:G"]) * 0.02);
        }
        else if(this.props.contentModel.id == "NumberInputField_678") {
            this.value = parseFloat(this.props.form.dbVariableStore["G:FI_DEV_TotalUndevReservesR2P2:G"]) * (parseFloat(this.props.form.dbVariableStore["G:FI_DEC_PercentToDevelopLevelR2P2:G"]) * 0.02);
        }
        else if(this.props.contentModel.variable == "G:FI_RES_StartingUndevReservesR1P1:G") {
            this.value = parseFloat(this.props.form.dbVariableStore["G:FI_DEV_TotalUndevReservesR1P1:G"]) - parseFloat(this.props.form.dbVariableStore["G:FI_RES_NewUndevReservesR1P1:G"]);
        }
        else if(this.props.contentModel.variable == "G:FI_RES_StartingUndevReservesR1P2:G") {
            this.value = parseFloat(this.props.form.dbVariableStore["G:FI_DEV_TotalUndevReservesR1P2:G"]) - parseFloat(this.props.form.dbVariableStore["G:FI_RES_NewUndevReservesR1P2:G"]);
        }
        else if(this.props.contentModel.variable == "G:FI_RES_StartingUndevReservesR2P1:G") {
            this.value = parseFloat(this.props.form.dbVariableStore["G:FI_DEV_TotalUndevReservesR2P1:G"]) - parseFloat(this.props.form.dbVariableStore["G:FI_RES_NewUndevReservesR2P1:G"]);
        }
        else if(this.props.contentModel.variable == "G:FI_RES_StartingUndevReservesR2P2:G") {
            this.value = parseFloat(this.props.form.dbVariableStore["G:FI_DEV_TotalUndevReservesR2P2:G"]) - parseFloat(this.props.form.dbVariableStore["G:FI_RES_NewUndevReservesR2P2:G"]);
        }
        else if(this.props.contentModel.variable == "G:FI_RES_AvgGlobalRefinedProdMktPrice:G") {
            this.value = parseFloat(this.props.form.dbVariableStore["G:FI_RES_AvgGlobalRefinedProdMktPrice:G"]) * 42;
        }
        else if(this.props.contentModel.variable == "G:FI_RES_AvgGlobalRefinedProdMktPriceR2:G") {
            var price = 2.21;
            if(window.application.dataModel.domainStore.context.team.num5 >= 2) { price = 2.15; }
            if(window.application.dataModel.domainStore.context.team.num5 >= 3) { price = 2.25; }
            this.value = price * 42;
        }
        else if(this.props.contentModel.id == "FormAccordionTop_MarketShare") {
            this.value = (this.props.form.dbVariableStore["G:FI_RES_ForecastedMktShareR1:G"] + this.props.form.dbVariableStore["G:FI_RES_ForecastedMktShareR2:G"]) / 2;
        }
        else {
            this.value = this.props.form.dbVariableStore[this.props.contentModel.variable];
        }

        if(this.props.contentModel.id == "NumberInputField_ExplorationField18") {
            this.props.contentModel.max = parseInt(this.props.form.dbVariableStore["G:FI_RES_TotBlocksAvailR1P1:G"]);
        }
        else if(this.props.contentModel.id == "NumberInputField_ExplorationField39") {
            this.props.contentModel.max = parseInt(this.props.form.dbVariableStore["G:FI_RES_TotBlocksAvailR1P2:G"]);
        }
        else if(this.props.contentModel.id == "NumberInputField_ExplorationField61") {
            this.props.contentModel.max = parseInt(this.props.form.dbVariableStore["G:FI_RES_TotBlocksAvailR2P1:G"]);
        }
        else if(this.props.contentModel.id == "NumberInputField_ExplorationField81") {
            this.props.contentModel.max = parseInt(this.props.form.dbVariableStore["G:FI_RES_TotBlocksAvailR2P2:G"]);
        }

        if(["DropDownInputField_539", "DropDownInputField_194"].indexOf(this.props.contentModel.id) >= 0) {
            let used = [];
            if(window.application.dataModel.domainStore.context.team.num5 >= 2) {
                used.push(this.props.form.dbVariableStore["G:FI_DEC_Initiative1:1"]);
                used.push(this.props.form.dbVariableStore["G:FI_DEC_Initiative2:1"]);
            }
            if(window.application.dataModel.domainStore.context.team.num5 >= 3) {
                used.push(this.props.form.dbVariableStore["G:FI_DEC_Initiative1:2"]);
                used.push(this.props.form.dbVariableStore["G:FI_DEC_Initiative2:2"]);
            }
            if(used.length >= 0) {
                for(let u = 0; u < used.length; ++u) {
                    for(let i = 0; i < this.props.contentModel.options.length; ++i) {
                        if(this.props.contentModel.options[i].value == used[u]) {
                            this.props.contentModel.options.splice(i, 1);
                            break;
                        }
                    }
                }
            }
        }

        this.save();
        this.validate();
    }
}


export class TextInputFieldViewStore extends InputFieldViewStore {

    @action.bound validate() {

        const {
            minLength,
            maxLength,
            validationRegex,
        } = this.props.contentModel; // this contentModel's properties

        const value = this.value;

        try {
            this.valid = value && value.length >= minLength && value.length <= maxLength && (!validationRegex || (new RegExp(validationRegex)).test(value));
        }
        catch(err) {
            console.error("There was an error executing the regex " + validationRegex + ". " + err.message);
            debugger;
            this.valid = false;
        }
    }

}

export class NumberInputFieldViewStore extends InputFieldViewStore {

    @action.bound validate() {

        const {
            min,
            max,
            decimals,
        } = this.props.contentModel; // this contentModel's properties

        const value = this.value;

        try {
            var number = parseFloat(value);
            this.valid = !isNaN(number) && number >= min && number <= max;
        }
        catch(err) {
            this.valid = false;
        }
    }

    @action.bound onBlur() {
        if(this.props.contentModel.isReadOnly || this.props.contentModel.disabled || this.props.form.props.contentModel.isSubmitted) {
            return;
        }
        const {
            min,
            max,
            decimals,
        } = this.props.contentModel; // this contentModel's properties

        this.hasFocus = false;

        try {
            var number = parseFloat(this.value);
            if(isNaN(number) && this.value != this.lastValue) {
                // don't show the number, just return to the previous value;
                this.value = this.lastValue;
                this.onBlur();
                return;
            }

            if(decimals <= 0) {
                number = Math.floor(number);
            }
            else {
                var ex = Math.pow(10, decimals);
                number = Math.floor(number * ex) / ex;
            }

            this.value = number + "";

            this.validate();

            if(this.props.form) {
                this.props.form.update();
            }
            
            return;
        }
        catch(err) {
            // there was an error, don't change the value
            this.value = this.lastValue;
        }
    }
}

export class SliderInputFieldViewStore extends InputFieldViewStore {
    
    @action.bound validate() {
        
        const {
            min,
            max,
            step,
        } = this.props.contentModel; // this contentModel's properties

        const value = this.value;
        
        try {
            var number = parseFloat(value);
            this.valid = !isNaN(number) && number >= min && number <= max;// && (number % step == 0);
        }
        catch(err) {
            this.valid = false;
        }

        this.events.onMouseUp = this.onMouseUp;
        this.events.onKeyUp = this.onKeyUp;
    }

    @action.bound onChange(value) {
        if(this.props.contentModel.isReadOnly || this.props.contentModel.disabled || this.props.form.props.contentModel.isSubmitted) {
            return;
        }
        this.value = value;

        this.validate();
    }

    @action.bound onFocus() {
        if(this.props.contentModel.isReadOnly || this.props.contentModel.disabled || this.props.form.props.contentModel.isSubmitted) {
            return;
        }
        this.hasFocus = true;
    }

    @action.bound onBlur() {
        if(this.props.contentModel.isReadOnly || this.props.contentModel.disabled || this.props.form.props.contentModel.isSubmitted) {
            return;
        }
        this.hasFocus = false;
    }
    
    @action.bound onMouseUp() {
        if(this.props.contentModel.isReadOnly || this.props.contentModel.disabled || this.props.form.props.contentModel.isSubmitted) {
            return;
        }
        
        if(this.props.form) {
            this.props.form.update();
        }
    }
    
    @action.bound onKeyUp() {
        if(this.props.contentModel.isReadOnly || this.props.contentModel.disabled || this.props.form.props.contentModel.isSubmitted) {
            return;
        }
        
        if(this.props.form) {
            this.props.form.update();
        }
    }
}

export class CheckboxInputFieldViewStore extends InputFieldViewStore {

    @computed get checked() {
        return this.value == "1";
    }

    @action.bound check() {
        this.value = "1";
    }

    @action.bound uncheck() {
        this.value = "0";
    }
    
    @action.bound toggle() {
        this.value = this.checked ? "0" : "1";
    }
    
    @action.bound validate() {
        this.valid = !this.props.contentModel.required || this.checked;
    }

    @action.bound onChange(value) {
        if(this.props.contentModel.isReadOnly || this.props.contentModel.disabled || this.props.form.props.contentModel.isSubmitted) {
            return;
        }
        this.toggle();

        this.validate();

        if(this.props.form) {
            this.props.form.update();
        }
    }

    @action.bound onFocus() {
        if(this.props.contentModel.isReadOnly || this.props.contentModel.disabled || this.props.form.props.contentModel.isSubmitted) {
            return;
        }
        this.hasFocus = true;
    }

    @action.bound onBlur() {
        if(this.props.contentModel.isReadOnly || this.props.contentModel.disabled || this.props.form.props.contentModel.isSubmitted) {
            return;
        }
        this.hasFocus = false;
    }
}

export class PasswordInputFieldViewStore extends InputFieldViewStore {

    @action.bound validate() {
        
        const {
            minLength,
            maxLength,
            validationRegex,
        } = this.props.contentModel; // this contentModel's properties

        const value = this.value;

        try {
            this.valid = value.length >= minLength && value.length <= maxLength && (!validationRegex || (new RegExp(validationRegex)).test(value));
        }
        catch(err) {
            console.error("There was an error executing the regex " + validationRegex + ". " + err.message);
            debugger;
            this.valid = false;
        }
    }
}

export class RadioInputFieldViewStore extends InputFieldViewStore {
    
    @action.bound validate() {
      this.valid = this.value !== undefined;
    }

    @action.bound onChange(value) {
        if(this.props.contentModel.isReadOnly || this.props.contentModel.disabled || this.props.form.props.contentModel.isSubmitted) {
            return;
        }
        this.value = value;

        this.validate();

        if(this.props.form) {
            this.props.form.update();
        }
    }

    @action.bound onFocus() {
        if(this.props.contentModel.isReadOnly || this.props.contentModel.disabled || this.props.form.props.contentModel.isSubmitted) {
            return;
        }
        this.hasFocus = true;
    }

    @action.bound onBlur() {
        if(this.props.contentModel.isReadOnly || this.props.contentModel.disabled || this.props.form.props.contentModel.isSubmitted) {
            return;
        }
        this.hasFocus = false;
    }
}

export class DropDownInputFieldViewStore extends InputFieldViewStore {

    @action.bound validate() {
        const options = this.props.contentModel.options;
        this.valid = false;
        for(var i = 0; i < options.length; ++i) {
          if(options[i].value == this.value) {
            this.valid = true;
            break;
          }
        }
    }

    @action.bound onChange(value) {
        if(this.props.contentModel.isReadOnly || this.props.contentModel.disabled || this.props.form.props.contentModel.isSubmitted) {
            return;
        }
        this.value = value;

        this.validate();

        if(this.props.form) {
            this.props.form.update();
        }
    }

    @action.bound onFocus() {
        if(this.props.contentModel.isReadOnly || this.props.contentModel.disabled || this.props.form.props.contentModel.isSubmitted) {
            return;
        }
        this.hasFocus = true;
    }

    @action.bound onBlur() {
        if(this.props.contentModel.isReadOnly || this.props.contentModel.disabled || this.props.form.props.contentModel.isSubmitted) {
            return;
        }
        this.hasFocus = false;
    }
}

export class TextAreaInputFieldViewStore extends InputFieldViewStore {
}


// WEBPACK FOOTER //
// ./app_modules/form-control-activity/inputFields/viewstore.js